export const USCGResourceKindOptions = [
  { value: 'Personnel', label: 'Personnel' },
  { value: 'Equipment', label: 'Equipment' },
  { value: 'Teams', label: 'Teams' },
  { value: 'Supplies', label: 'Supplies' },
  { value: 'Facilities', label: 'Facilities' },
  { value: 'Epidemiological Supplies', label: 'Epidemiological Supplies' },
  { value: 'Epidemiologists', label: 'Epidemiologists' },
  { value: 'Epidemiological Equipment', label: 'Epidemiological Equipment' },
  {
    value: 'Epidemiological Response Teams',
    label: 'Epidemiological Response Teams',
  },
];

export const TypeOptions = [
  {
    label: 'Type 1',
    value: 'Type 1',
  },
  {
    label: 'Type 2',
    value: 'Type 2',
  },
  {
    label: 'Type 3',
    value: 'Type 3',
  },
  {
    label: 'Type 4',
    value: 'Type 4',
  },
];
